<template>
  <div class="hopperContainer noSelect" @mousedown="startSlide">
    <div class="scrollBox" id="scrollBox" ref="carousel">
      <div class="card slide first-child">
        <div class="image-essilor">
          <SlideImage :hover="hover" @changehoverValue="endHover" v-show="!selecting" marque="essilor" />
        </div>
      </div>
      <div class="card slide" v-for="(marque, index) in ranges" v-bind:key="marque.id">
        <SlideImage hover="false" v-show="!selecting" @changehoverValue="endHover" :marque="marque" :index="index" />
      </div>
      <div class="card slide">
        <div class="end-message">
          <span>VOIR PLUS</span>
          <span>VIVRE PLUS</span>
        </div>
      </div>
      <div class="card spacer"></div>
    </div>
  </div>
</template>

<script>
import 'hooper/dist/hooper.css';
import SlideImage from '@Components/SlideImage.vue';

export default {
  name: 'App',
  components: {
    SlideImage,
  },
  props: ['scale', 'widthApp'],
  data() {
    return {
      selecting: false,
      hover: 'true',
      scrollBox: null,
      scrollPosition: 0,
      maxScroll: 0,
      buttonScrollValue: 200,
      scrollSpeed: 70,
      isCliked: false,
      positionClickOnClick: null,
      scrollPositionOnClick: null,
    };
  },
  mounted() {
    //get the scrollbox element for further operation
    this.scrollBox = document.getElementById('scrollBox');

    //reset the scroll position of the carousel
    this.scrollBox.scrollLeft = 0;

    this.scrollPosition = 0;
    //make a first calculation for what the maximum scroll value is
    this.maxScroll = this.scrollBox.scrollWidth - this.scrollBox.clientWidth;

    //attached event event to specific method in order to scroll using the wheel
    if (this.scrollBox.addEventListener) {
      // IE9, Chrome, Safari, Opera
      this.scrollBox.addEventListener('mousewheel', this.scrollHorizontally, false);
      // Firefox
      this.scrollBox.addEventListener('DOMMouseScroll', this.scrollHorizontally, false);
    } else {
      // IE 6/7/8
      this.scrollBox.attachEvent('onmousewheel', this.scrollHorizontally);
    }

    //attached move event to a method for the entire window
    window.addEventListener('mousemove', this.cursorMove);
    window.addEventListener('touchmove', this.updatePositionTouch);

    //detect release of the click to prevent mose to keep moving
    window.addEventListener('mouseup', () => {
      this.isCliked = false;
    });
  },
  computed: {
    ranges() {
      return this.$store.getters.getRanges();
    },
  },
  methods: {
    //called once the pre-selected hover in the essilor panel need to be desable
    endHover() {
      this.hover = 'false';
    },
    //scroll the carousel in a given direction
    slideCarouselButton(dir) {
      this.maxScroll = this.scrollBox.scrollWidth - this.scrollBox.clientWidth;
      this.scrollBox.scrollLeft += dir * this.buttonScrollValue;
      this.scrollPosition = this.scrollBox.scrollLeft;
    },
    //Scroll the carousel using the wheel
    scrollHorizontally(e) {
      e = window.event || e;
      var delta = Math.max(-1, Math.min(1, e.wheelDelta || -e.detail));
      this.scrollBox.scrollLeft -= delta * this.scrollSpeed;
      this.scrollPosition = this.scrollBox.scrollLeft;
      e.preventDefault();
    },
    //get a snapshot of the cursor and scroll position when click is pushed down
    startSlide(event) {
      this.isCliked = true;
      this.positionClickOnClick = this.getCursorPos(event);
      this.scrollPositionOnClick = this.scrollBox.scrollLeft;
    },
    //scroll as much as the difference in pixel between the first click and the curent position
    cursorMove(event) {
      if (this.isCliked) {
        this.scrollPosition = this.scrollPositionOnClick - (this.getCursorPos(event) - this.positionClickOnClick);
      }
    },
    // return x cursor position
    getCursorPos(event) {
      return event.pageX - this.scrollBox.getBoundingClientRect().left;
    },
    //update scroll position when touch event is detected
    updatePositionTouch() {
      this.scrollPosition = this.scrollBox.scrollLeft;
    },
  },
  watch: {
    //watch the position of the scroll to update the position of the div
    scrollPosition: function() {
      this.$emit('updateCarousel');
      this.scrollBox.scrollLeft = this.scrollPosition;
    },
    //when the scale of the carousel shrink, calculation need to be made to change the
    //margins and width of the carousel so that proportion stay correct
    scale: function() {
      if (this.scale < 1) {
        //create a style element to inject it in the html
        var style = document.createElement('style');
        document.head.appendChild(style);

        //calculate the width of the div to better match the appContainer
        var widthOffset = (100 * 100) / (this.scale * 100);
        //calculate the left margin considering the shrinked div
        var leftOffset = -((widthOffset - 100) * this.widthApp) / 200;

        //offset the margin a bit more if it's on firefox
        if (navigator.userAgent.toLowerCase().indexOf('firefox') > -1) {
          leftOffset -= 6;
        }

        //apply the css style
        style.sheet.insertRule('.scrollBox {width: ' + widthOffset.toString(10) + '%}');
        style.sheet.insertRule('.scrollBox {left: ' + leftOffset.toString(10) + 'px}');

        //calculate the max scroll value when the scale is updated
        this.maxScroll = this.scrollBox.scrollWidth - this.scrollBox.clientWidth;
      }
    },
  },
};
</script>

<style scoped>
.noSelect {
  -webkit-touch-callout: none;
  -webkit-user-select: none;
  -khtml-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

.spacer {
  width: 50px;
}

.scrollBox {
  scrollbar-width: none;
  -ms-overflow-style: none;
  position: relative;
  display: flex;
  flex-wrap: nowrap;
  overflow-x: scroll;
  align-content: center;
  height: -webkit-calc(100% - 128px);
  height: -moz-calc(100% - 128px);
  height: calc(100% - 128px);
  min-height: 560px;
  overflow-y: hidden;
}

.hopperContainer {
  height: 100%;
  position: relative;
  bottom: 0;
}

.scrollBox::-webkit-scrollbar {
  display: none;
}

.slide::-webkit-scrollbar {
  display: none;
}

.card {
  flex: 0 0 auto;
}

.slide {
  width: 320px !important ;
  height: 760px;
  background-color: transparent;
  margin-right: 64px;
  display: -webkit-flex;
  display: flex;
  -webkit-justify-content: center;
  justify-content: center;
  -webkit-align-items: center;
  align-items: center;
  color: #fff;
  font-size: 30px;
}

.slide:first-child {
  width: 800px !important;
  justify-content: flex-end;
  color: #121212;
}

.bottom .center {
  z-index: -1;
  width: 0%;
}

.image-essilor {
  width: 704px;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.logo {
  position: absolute;
  z-index: 10;
}

.start-message {
  font-size: 75px;
  display: flex;
  flex-direction: column;
  position: absolute;
  left: 230px;
  display: flex;
  align-items: flex-end;
  z-index: 10;
}

.end-message {
  font-size: 75px;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  color: black;
  margin-left: 8px;
}

@media screen and (min-width: 0\0) {
  .start-message {
    font-size: 75px;
    position: absolute;
    left: 10px;
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    z-index: 10;
    bottom: 25%;
  }
}
</style>
